import React from 'react'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { contactImg } from "../../assets/index";
import { Link } from 'react-router-dom';
import { SiFiverr } from 'react-icons/si';

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">M.Wahaj Khan</h3>
        <p className="text-lg font-normal text-gray-400">
          MERN Stack Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          Hello! This is Wahaj a Full Stack Website developer having experience in 
          HTML5, CSS3, JavaScript React JS , Node JS , Express JS , MongoDB , Firebase.
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+92 3317534725</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">khanwahaj510@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
            <Link to='https://www.facebook.com/profile.php?id=100093795650530' target='_blank'><FaFacebookF /></Link>
          </span>
          <span className="bannerIcon">
            <Link to='https://www.linkedin.com/in/m-wahaj-khan/' target='_blank'><FaLinkedinIn /></Link>
          </span>
          <span className="bannerIcon">
            <Link to='https://www.instagram.com/wahaj.x.x/' target='_blank'><FaInstagram /></Link>
          </span>
          <span className="bannerIcon">
            <Link to='https://www.fiverr.com/wahaj_kh/design-website-responsive-using-html-css-bootstrap-website' target='_blank'><SiFiverr /></Link>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft